// MobileLanding.tsx 
import React from 'react';
import logo from '../../../Assets/images/Logo/logo.png';
import AmericanFlag from '../../../Assets/images/Flags/English.png';
import BgImage from '../../../Assets/images/BgImage/number_background.png';
import Preview from '../../../Assets/images/LandingPageImage/preview.png';
import PoweredBy from '../../../Assets/images/SALogo.png';
import HowToPlayButton from './LandingComponents/Buttons/HowToPlayButton';
import GooglePlayButton from './LandingComponents/Buttons/GoogleStoreButton';
import AppStoreButton from './LandingComponents/Buttons/AppleStoreButton';
import SocialLinks from './SocialLinks';
import CopyrightFooter from './CopyRightFooter';
import '../../../Assets/styles/LandingStyles/Footer.css';
import '../../../Assets/styles/LandingStyles/MobileLanding.css';
import TutorialButton from './LandingComponents/Buttons/TutorialsButton';
import CookieConsentBanner from './CookieBanner/CookieConsentBanner';

const MobileLanding: React.FC = () => (
    <div className="mobile-App">
        <CookieConsentBanner />

        {/* HEADER */}
        <header className="mobile-header">
            <img src={logo} alt="Sudoku VS Logo" className="logo" />

            <div className="tutorial_button_container">
                <TutorialButton />
            </div>
            <div className="flag-container">
                <img src={AmericanFlag} alt="American Flag" className="flag" />
            </div>
        </header>

        {/* GRADIENT */}
        <div className="mobile-gradient" />

        {/* MAIN CONTENT */}
        <div className="mobile-main-container">
            {/* Preview section */}
            <div className="mobile-preview-section">
                <div
                    className="mobile-bg-container mobile-clip-slanted"
                    style={{ backgroundImage: `url(${BgImage})` }}
                />
                <div className="mobile-preview-container">
                    <img
                        src={Preview}
                        alt="Sudoku VS Preview"
                        className="mobile-preview-image"
                    />
                </div>
            </div>

            {/* CTA section */}
            <div className="mobile-content-section">
                <h1 className="mobile-heading">Play Sudoku Vs Now!</h1>
                <p className="mobile-paragraph">
                    <strong>Get ready for a Sudoku challenge like no other!</strong> Enjoy solo practice or face off against friends &mdash; download now and experience the excitement!
                </p>
            </div>

            {/* Buttons section */}
            <div className="mobile-buttons-container">
                <HowToPlayButton />
                <GooglePlayButton />
                <AppStoreButton />
            </div>

            {/* Social Media section */}
            <div className="mobile-social-section">
                <p className="mobile-follow-us-text">FOLLOW US ON</p>
                <SocialLinks />
                <p className="mobile-handle">@SUDOKU.VS</p>
            </div>
            <CopyrightFooter />
        </div>
    </div>
);

export default MobileLanding;